module.exports = __webpack_public_path__ + "static/media/LWC-PRESS1.def0b1d6.png";